import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse";
import { ListPrescriptionFeedbackQueryParamsDTO } from "@/domain/dto/ListPrescriptionFeedbackQueryParamsDTO";
import { PrescriptionFeedback } from "@/domain/entities/PrescriptionFeedback";
import { IUserRepository } from "@/domain/repositories/IUserRepository";
import { IListPrescriptionFeedbackUseCase } from "@/domain/usecases/IListPrescriptionFeedbackUseCase";

export class ListPrescriptionFeedbackUseCase implements IListPrescriptionFeedbackUseCase {
    repository: IUserRepository
    constructor(repository: IUserRepository) {
        this.repository = repository
    }

    execute(params: ListPrescriptionFeedbackQueryParamsDTO): Promise<PaginatedListResponse<PrescriptionFeedback>> {
        return this.repository.listPrescriptionFeedback(params)
    }
}
